/* tslint:disable:typedef-whitespace no-trailing-whitespace */

import {TaskUpdate, TaskUpdateType} from "@/models/task.update";

/**
 *
 * @class TaskUpdateClear
 *
 * @brief sentinel update, clear a progress stream.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      December 2021
 *
 */
export class TaskUpdateClear extends TaskUpdate {

  /**
   * standard constructor, you have to uniquely identify the task progress stream (id)
   * and provide the type of progress update (type).
   *
   * @param id the unique id of the task progress stream to clear (the context)
   *
   */
  constructor(id: string) {

    super(id, TaskUpdateType.Clear, 100.0);

  }


  /** subclasses that can render their own update should return non-empty HTML */
  render(): string {

    return '';
  }


}
